import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClientService } from './../../providers';
import { ERRCODES } from 'config';


@Component({
  selector: 'app-server-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  errCode: string;
  errMessage: string;
  constructor(private route: ActivatedRoute,
    private httpClientService: HttpClientService) { }

  ngOnInit() {
    console.log('Entering error handling');
    this.errCode = this.route.snapshot.params['errCode'];
      this.errMessage = ERRCODES[this.errCode];
    }
  }

